import SpintrLoader from "src/ui/components/Loader";
import { GroupedTableLoadingRowRenderProps } from "../types";

function GroupedTableLoadingRow<TRow>({
    indentPx,
}: GroupedTableLoadingRowRenderProps<TRow>): JSX.Element {
    return (
        <div className="GroupedTableLoadingRow" style={{ paddingLeft: indentPx }} >
            <SpintrLoader loaderSize="small" />
        </div>
    );
}

export default GroupedTableLoadingRow;
